import * as React from 'react';
import { Col, Row } from 'reactstrap';
import FAIcon from '../fAIcon/FAIcon';
import './CPCourseItemEditComponent.css';

export interface CPCourseItemEditComponentProps {
    content: React.ReactNode;
    contentEdit: React.ReactNode;
    onClickHandler: () => void;
    editState: boolean;
    name?: string;
}

export const CPCourseItemEditComponent = (props: CPCourseItemEditComponentProps) => {
    if (!props.editState) {
        return (
            <div className="mt-2 mb-4 CPCourseItemEditComponent">
                {props.name && <label>{props.name}</label>}
                <Row className="MyItem">
                    <Col md={11}>{<Row className="mt-2 mb-2">{props.content}</Row>}</Col>
                    <a className="iconButton" onClick={props.onClickHandler}>
                        <FAIcon mouseHover="bearbeiten" icon="plus-circle" />
                    </a>
                </Row>
            </div>
        );
    } else {
        return (
            <div className="mt-2 mb-4 CPCourseItemEditComponent">
                {props.name && <label>{props.name}</label>}
                <Row className="MyItem editing">
                    <Col md={11}>
                        <Row className="mt-2 mb-2">{props.contentEdit}</Row>
                    </Col>
                    <a className="iconButton" onClick={props.onClickHandler}>
                        <FAIcon icon="minus-circle" />
                    </a>
                </Row>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/cpCoursesTableBox/CPCourseItemEditComponent.tsx